// extracted by mini-css-extract-plugin
export var attribution = "_d1-4";
export var authorName = "_d1-5";
export var quote = "_d1-3";
export var testimonial = "_d1-2";
export var trustedBy = "_d1-0";
export var trustedByLabel = "_d1-1";